import type { SiteData } from "../types";

export function setupSeeds(siteData: SiteData): SiteData {
  const rounds = Math.log(siteData.bracketSize) / Math.log(2) - 1;
  let seeds = [1, 2];
  for (let i = 0; i < rounds; i += 1) {
    seeds = nextLayer(seeds);
  }

  function nextLayer(seeds: number[]): number[] {
    const out: number[] = [];
    const length = seeds.length * 2 + 1;
    seeds.forEach((d) => {
      out.push(d);
      out.push(length - d);
    });
    return out;
  }

  const updated = structuredClone(siteData);
  updated.bracketsModeSettings.gameSeedSetup.seedList = seeds;
  return splitSeeds(updated);
}

export function splitSeeds(siteData: SiteData): SiteData {
  const updated = structuredClone(siteData);
  let seedCount = 1;
  const { gameSeedSetup } = updated.bracketsModeSettings;
  for (let x = 0; x < updated.bracketSize; x += 2) {
    const song1 = gameSeedSetup.seedList[x]!;
    const song2 = gameSeedSetup.seedList[x + 1]!;
    gameSeedSetup.activeSeeds["seed" + seedCount] = [song1, song2];
    seedCount += 1;
  }
  updated.bracketsModeSettings.maxSeeds = seedCount;
  updated.bracketsModeSettings.current2Seeds =
    gameSeedSetup.activeSeeds["seed1"]!;
  return updated;
}
